export default "__VITE_ASSET__BcaLLskl__"